import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { toastr } from "react-redux-toastr";
import {
	FormGroup,
	FormControl,
	FormLabel,
	Row,
	Col,
	InputGroup,
} from "react-bootstrap";
import { FiCalendar, FiTrash2, FiClock } from "react-icons/fi";
import { MdPlaylistAddCheck } from "react-icons/md";
import moment from "moment";
import Moment from "react-moment";
import Dropzone from "react-dropzone";
import { expensesService, expenseGroupingsService, expStatus } from "services";
import CreatableSelect from "react-select/creatable";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import { get_expense_status_name } from "components/Expenses";
import "./Expenses.scss";
import * as expensesActions from "actions/expensesActions";

class ExpenseEdit extends React.Component {
	constructor(props) {
		super(props);
		const estados_gasto = this.props.expense_status;
		const estado_pendiente_id = estados_gasto.find(
			(item) => item.name === expStatus.pending
		)?.id;

		let expense = {
			day: "",
			comments: "",
			answer_comments: "",
			payer_comments: "",
			value: 0,
			provider_id: "",
			type_id: "",
			payment_type_id: "",
			status: get_expense_status_name(estado_pendiente_id, estados_gasto),
		};

		let isEdit = false;
		let selectedGrouping = null;

		if (props.expense) {
			expense = {
				...props.expense,
				provider_id:
					props.expense.provider_id ?? props.expense.provider?.id ?? "",
				type_id: props.expense.type_id ?? props.expense.type?.id ?? "",
				payment_type_id:
					props.expense.payment_type_id ?? props.expense.payment_type?.id ?? "",
			};
			isEdit = true;
			if (expense.grouping || expense.grouping_id) {
				const groupingId = expense.grouping?.id ?? expense.grouping_id;
				const groupingFromStore = props.expense_groupings?.find(
					(g) => g.id === groupingId
				);
				const groupingName =
					groupingFromStore?.name ??
					expense.grouping?.name ??
					String(groupingId);
				expense.grouping_id = groupingId;
				selectedGrouping = { value: groupingId, label: groupingName };
			}
		}

		const initialMaxValue =
			props.expense?.type?.max_value ??
			props.expense_types?.find((t) => String(t.id) === String(expense.type_id))
				?.max_value ??
			null;

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			expense,
			typeMaxValue: initialMaxValue,
			status_name: get_expense_status_name(expense.status, estados_gasto),
			disabled: props.disabled ? true : false,
			files: [],
			selectedGrouping,
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.expense !== this.props.expense) {
			const { expense, expense_groupings } = this.props;
			if (!expense) return;

			const newExpense = {
				...expense,
				provider_id: expense.provider_id ?? expense.provider?.id ?? "",
				type_id: expense.type_id ?? expense.type?.id ?? "",
				payment_type_id:
					expense.payment_type_id ?? expense.payment_type?.id ?? "",
			};

			let selectedGrouping = null;
			if (expense.grouping || expense.grouping_id) {
				const groupingId = expense.grouping?.id ?? expense.grouping_id;
				newExpense.grouping_id = groupingId;
				const groupingFromStore = expense_groupings?.find(
					(g) => g.id === groupingId
				);
				const groupingName =
					groupingFromStore?.name ??
					expense.grouping?.name ??
					String(groupingId);
				selectedGrouping = { value: groupingId, label: groupingName };
			}

			this.setState({ expense: newExpense, selectedGrouping });
		}
	}

	handleChange = (event) => {
		const { expense } = this.state;
		const { id, value } = event.target;

		const updatedExpense = { ...expense, [id]: value };

		const stateUpdate = { expense: updatedExpense };

		if (id === "type_id") {
			const found = this.props.expense_types?.find(
				(t) => String(t.id) === String(value)
			);
			stateUpdate.typeMaxValue = found?.max_value ?? null;
		}

		this.setState(stateUpdate);
	};

	handleDateChange = (id, date) => {
		const { expense } = this.state;

		let key = id;
		let value = moment(date).format("YYYY-MM-DD");

		this.setState({
			expense: {
				...expense,
				[key]: value,
			},
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });
		let response = "";
		const props = this.props;
		const { files } = this.state;

		const { grouping, ...expense_to_save } = this.state.expense;

		// if edit => update; else => new
		if (this.state.isEdit) {
			response = await expensesService.update(expense_to_save);
		} else {
			response = await expensesService.add(expense_to_save);
		}

		if (response.ok) {
			const savedId = response.id ?? expense_to_save.id;

			// upload pending files if any
			if (files.length > 0 && savedId) {
				const formData = new FormData();
				files.forEach((file) => formData.append("filename", file));
				await expensesService.updateAttachments(savedId, formData);
			}

			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
					this.props.getExpenses();
					props.handleClose();
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	handleGroupingChange = (option) => {
		this.setState({
			selectedGrouping: option,
			expense: {
				...this.state.expense,
				grouping_id: option ? option.value : null,
			},
		});
	};

	handleGroupingCreate = async (inputValue) => {
		const response = await expenseGroupingsService.add({
			name: inputValue,
			enabled: true,
		});
		if (response.ok) {
			const newOption = { value: response.id, label: inputValue };
			await this.props.getAllExpenseGroupings();
			this.setState({
				selectedGrouping: newOption,
				expense: {
					...this.state.expense,
					grouping_id: response.id,
				},
			});
		} else {
			toastr.error("Error", this.props.t('expenses.editModal.errorCreateGrouping'));
		}
	};

	onDrop = (files) => {
		this.setState({ files });
	};

	removeFile = (file) => {
		const { files } = this.state;
		this.setState({
			files: files.filter((f) => f.lastModified !== file.lastModified),
		});
	};

	getAttachment = async (attachment) => {
		const { expense } = this.state;
		const response = await expensesService.getAttachment(
			expense.id,
			attachment.url
		);
		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = attachment.name;
		a.click();
	};

	removeAttachment = async (attachment) => {
		const { expense } = this.state;
		const response = await expensesService.removeAttachment(
			expense.id,
			attachment.url
		);
		if (response.ok) {
			this.setState({
				expense: {
					...expense,
					attachments: expense.attachments.filter(
						(att) => att.url !== attachment.url
					),
				},
			});
		} else {
			toastr.error("Error", this.props.t('expenses.editModal.errorDeleteAttachment'));
		}
	};

	render() {
		const { providers, expense_types, expense_groupings, payment_types, t } = this.props;
		const { isEdit, expense, status_name, disabled, typeMaxValue, selectedGrouping } = this.state;

		const limitWarning =
			typeMaxValue != null &&
			typeMaxValue !== "" &&
			parseFloat(expense.value) > parseFloat(typeMaxValue)
				? t("expenses.editModal.limitWarning", { max: typeMaxValue })
				: null;
		const groupingOptions = (expense_groupings || []).map((grouping) => ({
			value: grouping.id,
			label: grouping.name,
		}));

		const option_providers =
			providers.length > 0 &&
			providers.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);
		const option_expense_types =
			expense_types.length > 0 &&
			expense_types.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<Row>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="type_id">
								<FormLabel>
									{t("expenses.editModal.category")} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									placeholder={t("expenses.editModal.category")}
									value={expense.type_id}
									isInvalid={this.checkValidField("type_id")}
									onChange={this.handleChange}
									disabled={disabled}
									as="select"
								>
									<option value="">{t("expenses.editModal.selectCategory")}</option>
									{option_expense_types}
								</FormControl>
								<FormControl.Feedback type="invalid">
									{this.state.errors.type_id}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						{(!disabled || expense.provider_id) && (
							<Col sm={6}>
								<FormGroup className="form-group" controlId="provider_id">
									<FormLabel>{t("expenses.editModal.provider")}</FormLabel>
									<FormControl
										value={expense.provider_id}
										isInvalid={this.checkValidField("provider_id")}
										onChange={this.handleChange}
										disabled={disabled}
										as="select"
									>
										<option value="">{t("expenses.editModal.selectProvider")}</option>
										{option_providers}
									</FormControl>
									<FormControl.Feedback type="invalid">
										{this.state.errors.provider_id}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
						)}

						{(!disabled || selectedGrouping) && (
							<Col sm={6}>
								<FormGroup className="form-group" controlId="grouping_id">
									<FormLabel>{t("expenses.editModal.grouping")}</FormLabel>
									{disabled ? (
										<p className="form-control-static">
											{selectedGrouping?.label}
										</p>
									) : (
										<CreatableSelect
											isClearable
											options={groupingOptions}
											value={selectedGrouping}
											onChange={this.handleGroupingChange}
											onCreateOption={this.handleGroupingCreate}
											placeholder={t("expenses.editModal.groupingPlaceholder")}
											formatCreateLabel={(input) =>
												t("expenses.editModal.createGrouping", { name: input })
											}
											noOptionsMessage={() =>
												t("expenses.editModal.noGroupingOptions")
											}
											classNamePrefix="react-select"
										/>
									)}
								</FormGroup>
							</Col>
						)}

						<Col sm={6} md={3}>
							<FormGroup
								controlId="day"
								className={`form-group form-date ${expense.day === "" && "empty"}  ${this.checkValidField("day") && "is-invalid"}`}
							>
								<FormLabel>
									{t("expenses.editModal.day")} <span className="label-required">*</span>
								</FormLabel>
								<DatePicker
									selected={
										expense.day === "" || expense.day === null
											? expense.day
											: moment(expense.day).toDate()
									}
									onChange={(date) => this.handleDateChange("day", date)}
									isInvalid={this.checkValidField("day")}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									locale="es"
									placeholderText="dd/mm/aaaa"
									disabled={disabled}
								/>
								<FiCalendar />
								<FormControl.Feedback type="invalid">
									{this.state.errors.day}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6} md={3}>
							<FormGroup className="form-group" controlId="value">
								<FormLabel>
									{t("expenses.editModal.amount")} <span className="label-required">*</span>
								</FormLabel>

								<InputGroup className="input-group-number">
									<FormControl
										type="text"
										placeholder="value"
										value={expense.value}
										onChange={this.handleChange}
										isInvalid={this.checkValidField("value")}
										disabled={disabled}
									/>
									<InputGroup.Text>&euro;</InputGroup.Text>
								</InputGroup>

								<FormControl.Feedback type="invalid">
									{this.state.errors.value}
								</FormControl.Feedback>
							</FormGroup>
						</Col>

						{(!disabled || expense.comments) && (
							<Col sm={12}>
								<FormGroup className="form-group" controlId="comments">
									<FormLabel>{this.props.t('expenses.labelComments')}</FormLabel>
									<FormControl
										as="textarea"
										value={expense.comments}
										onChange={this.handleChange}
										placeholder={this.props.t('expenses.labelComments')}
										isInvalid={this.checkValidField("comments")}
										disabled={disabled}
									/>
									<FormControl.Feedback type="invalid">
										{this.state.errors.comments}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
						)}

						<Col sm={12}>
							{disabled ? (
								<ul className="dropzone-files">
									{expense.attachments &&
										expense.attachments.map((attachment) => {
											var size = attachment.size / 1000000;
											var sizeLetters = "Mb";
											if (size < 1) {
												size = attachment.size / 1000;
												sizeLetters = "Kb";
											}
											return (
												<li className="file-item" key={attachment.url}>
													<span
														className="file-info"
														title={attachment.name}
														onClick={() => this.getAttachment(attachment)}
													>
														<span className="file-name">{attachment.name}</span>
														<span className="file-size">
															({size.toFixed(2)}
															{sizeLetters})
														</span>
													</span>
													<div className="file-action">
														<MdPlaylistAddCheck className="file-saved" />
													</div>
												</li>
											);
										})}
								</ul>
							) : (
								<Dropzone onDrop={this.onDrop}>
									{({ getRootProps, getInputProps }) => (
										<section className="dropzone-container">
											<FormLabel>{this.props.t('expenses.labelAttachments')}</FormLabel>
											<div {...getRootProps({ className: "dropzone" })}>
												<input {...getInputProps()} />
												<p>{this.props.t('expenses.dropzoneText')}</p>
											</div>
											<ul className="dropzone-files">
												{expense.attachments &&
													expense.attachments.map((attachment) => {
														var size = attachment.size / 1000000;
														var sizeLetters = "Mb";
														if (size < 1) {
															size = attachment.size / 1000;
															sizeLetters = "Kb";
														}
														return (
															<li className="file-item" key={attachment.url}>
																<span
																	className="file-info"
																	title={attachment.name}
																	onClick={() => this.getAttachment(attachment)}
																>
																	<span className="file-name">
																		{attachment.name}
																	</span>
																	<span className="file-size">
																		({size.toFixed(2)}
																		{sizeLetters})
																	</span>
																</span>
																<div className="file-action">
																	<MdPlaylistAddCheck className="file-saved" />
																	<button
																		type="button"
																		className="btn btn-icon"
																		title="Eliminar"
																		onClick={() =>
																			this.removeAttachment(attachment)
																		}
																	>
																		<FiTrash2 />
																	</button>
																</div>
															</li>
														);
													})}
												{this.state.files.map((file, i) => {
													var size = file.size / 1000000;
													var sizeLetters = "Mb";
													if (size < 1) {
														size = file.size / 1000;
														sizeLetters = "Kb";
													}
													return (
														<li className="file-item-temp" key={i}>
															<span className="file-info" title={file.name}>
																<span className="file-name">{file.name}</span>
																<span className="file-size">
																	({size.toFixed(2)}
																	{sizeLetters})
																</span>
															</span>
															<div className="file-action">
																<button
																	type="button"
																	className="btn btn-icon"
																	title="Eliminar"
																	onClick={() => this.removeFile(file)}
																>
																	<FiTrash2 />
																</button>
															</div>
														</li>
													);
												})}
											</ul>
										</section>
									)}
								</Dropzone>
							)}
						</Col>

						{isEdit && (
							<Col sm={12}>
								<div className="expense-info">
									<Row>
										<Col xs={6} sm={4}>
											<div className="expense-info-item">
												<span className="expense-info-label">{t("expenses.editModal.status")}</span>
												<span className={`estado ${expense.status} mt5`}>
													{t(`expenses.statusLabels.${expense.status}`, { defaultValue: expense.status })}
												</span>
											</div>
										</Col>
										{expense.requested && (
											<Col xs={6} sm={4}>
												<div className="expense-info-item">
													<span className="expense-info-label">
														{t("expenses.editModal.requestedBy")}
													</span>
													<span>
														{expense.requester?.name}{" "}
														{expense.requester?.surname}
													</span>
													<span className="expense-info-date">
														<Moment format="DD/MM/YYYY HH:mm">
															{expense.requested}
														</Moment>
													</span>
												</div>
											</Col>
										)}
										{expense.answerer && (
											<Col xs={6} sm={4}>
												<div className="expense-info-item">
													<span className="expense-info-label">
														{expense.status === expStatus.denied
															? t("expenses.editModal.deniedBy")
															: t("expenses.editModal.approvedBy")}
													</span>
													<span>
														{expense.answerer.name} {expense.answerer.surname}
													</span>
													{expense.answered && (
														<span className="expense-info-date">
															<Moment format="DD/MM/YYYY HH:mm">
																{expense.answered}
															</Moment>
														</span>
													)}
												</div>
											</Col>
										)}
										{expense.payer && (
											<Col xs={6} sm={4}>
												<div className="expense-info-item">
													<span className="expense-info-label">{t("expenses.editModal.paidBy")}</span>
													<span>
														{expense.payer.name} {expense.payer.surname}
													</span>
													{expense.paid && (
														<span className="expense-info-date">
															<Moment format="DD/MM/YYYY HH:mm">
																{expense.paid}
															</Moment>
														</span>
													)}
												</div>
											</Col>
										)}
										{expense.answer_comments && (
											<Col xs={6} sm={8}>
												<div className="expense-info-item">
													<span className="expense-info-label">
														{t("expenses.editModal.supervisorNotes")}
													</span>
													<span>{expense.answer_comments}</span>
												</div>
											</Col>
										)}

										{expense.payer_comments && (
											<Col xs={6} sm={8}>
												<div className="expense-info-item">
													<span className="expense-info-label">
														{t("expenses.editModal.payerNotes")}
													</span>
													<span>{expense.payer_comments}</span>
												</div>
											</Col>
										)}
									</Row>
								</div>
							</Col>
						)}
					</Row>

					{limitWarning && (
						<div className="alert alert-warning alert-limit" role="alert">
							{limitWarning}
						</div>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{disabled ? t("common.close") : t("common.cancel")}
					</button>
					{!disabled && (
						<SubmitButton
							type="submit"
							isLoading={this.state.isLoading}
							text={t("common.save")}
							loadingText={t("common.saving")}
						/>
					)}
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.expensesReducer;
};

export default connect(mapStateToProps, expensesActions)(withTranslation()(ExpenseEdit));
